import { ColDef, ValueGetterParams } from 'ag-grid-community';
import {
  createDateHasAllTimeCol,
  createIdCol,
  createNumberCol,
  createTypoCol,
  createStatusBadgeCol,
  createDetailButtonColV2,
} from '@/src/helpers/agColumnHelper';
import TableRowStatusBadge from '@/src/components/molecule/TableRowStatusBadge';
import Badge, { badgeColorData } from '@/src/components/atom/Badge';
import { NoticeCategory } from '@/src/models/NoticeDto';

const getNoticeCateogoryTypeBadgeProps = (
  type: NoticeCategory,
): {
  children: string;
  badgeColor: keyof typeof badgeColorData;
} => {
  switch (type) {
    case 'common':
      return {
        children: '일반 공지',
        badgeColor: 'lightBlue',
      };
    case 'community':
      return {
        children: '커뮤니티 공지',
        badgeColor: 'lightYellow',
      };
    default:
      return {
        children: '-',
        badgeColor: 'lightGray',
      };
  }
};

export const noticeListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateHasAllTimeCol({
    field: 'createdAt',
    width: 231,
    minWidth: 231,
    maxWidth: 300,
    headerName: '등록 일시',
  }),
  {
    headerClass: 'ag-right-aligned-cell',
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    field: 'categoryType',
    width: 143,
    minWidth: 143,
    maxWidth: 200,
    cellRenderer: (params: ValueGetterParams) => {
      return (
        <Badge
          {...getNoticeCateogoryTypeBadgeProps(params?.data?.categoryType)}
        />
      );
    },
    headerName: '유형',
  },
  createTypoCol({
    field: 'title',
    size: 'lg',
    flex: 2,
    headerName: '제목',
  }),
  {
    headerClass: 'ag-right-aligned-cell',
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    field: 'showedYn',
    width: 96,
    minWidth: 96,
    maxWidth: 96,
    cellRenderer: (params: ValueGetterParams) => {
      if (params.data.showedYn === true || params.data.showedYn === false) {
        return (
          <TableRowStatusBadge type="isViewable" value={params.data.showedYn} />
        );
      } else {
        return '-';
      }
    },
    headerName: '노출 여부',
  },
  createStatusBadgeCol({
    field: 'fixedTopYn',
    type: 'isApplied',
    size: 'sm',
    headerName: '우선 노출 여부',
  }),
  createNumberCol({
    field: 'viewCount',
    width: 147,
    minWidth: 147,
    maxWidth: 200,
    headerName: '조회 수',
  }),
  {
    headerClass: 'ag-right-aligned-cell',
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    field: 'adminName',
    width: 135,
    minWidth: 135,
    maxWidth: 300,
    cellRenderer: (params: ValueGetterParams) => {
      return params?.data?.administrator?.name || '-';
    },
    headerName: '등록 관리자',
  },
  createDetailButtonColV2(onDetailClick),
];
